import moment from "moment/moment";

export default function formatDateAndTime(isoString) {
  // if (typeof isoString !== "string" || !isoString.includes("T")) {
  //   console.error("Invalid ISO string:", isoString);
  //   return "";
  // }

  // const [datePart, timePart] = isoString.split("T");
  // const [year, month, day] = datePart.split("-");
  // const [hour, minute] = timePart.split(":");

  // let hour12 = parseInt(hour);
  // const ampm = hour12 >= 12 ? "PM" : "AM";
  // hour12 = hour12 % 12 || 12;

  // return `${parseInt(day)}/${parseInt(
  //   month
  // )}/${year}, ${hour12}:${minute} ${ampm}`;
  return moment(isoString).format("DD-MMM-YYYY hh:mm A")
}
